const permissionRoot = '/permission';

export const configurationPermissionRoutes = (root: string) => ({
  root: `${root}${permissionRoot}`,
  resourceGroups: {
    root: `${root}${permissionRoot}/resource-groups`,
    create: {
      root: `${root}${permissionRoot}/resource-groups/add`,
      details: () => `${root}${permissionRoot}/resource-groups/add/details`,
      monitoring: () => `${root}${permissionRoot}/resource-groups/add/monitoring`,
      events: () => `${root}${permissionRoot}/resource-groups/add/events`,
    },
    createPublic: {
      root: `${root}${permissionRoot}/resource-groups/add/public`,
      details: () => `${root}${permissionRoot}/resource-groups/add/public/details`,
      monitoring: () => `${root}${permissionRoot}/resource-groups/add/public/monitoring`,
      events: () => `${root}${permissionRoot}/resource-groups/add/public/events`,
    },
    edit: {
      root: `${root}${permissionRoot}/resource-groups/edit/:id`,
      details: () => `${root}${permissionRoot}/resource-groups/edit/:id/details`,
      monitoring: () => `${root}${permissionRoot}/resource-groups/edit/:id/monitoring`,
      events: () => `${root}${permissionRoot}/resource-groups/edit/:id/events`,
    },
  },
});
